module.exports = __webpack_public_path__ + "img/logo-sub-console.9ea9a81a.png";